import { Col, Form, Input, Row, Select } from "antd";
import { FormInstance } from "antd/lib/form";
import { isString } from "lodash";
import React from "react";

type FormType = {
  form: FormInstance<any>;
  values?: any;
  submit: (values: any) => void;
  data: any;
};

export const SizeGroupForm: React.FC<FormType> = (props) => {
  const { form, values, data, submit } = props;

  const {
    measureSizes: { nodes: measureSizes },
  } = data;

  const onFinish = (values: any) => {
    const input = {
      ...values,
      sizeSizeGroups: values.sizeSizeGroups?.map((sizeId: any) => ({
        sizeId,
      })),
    };
    submit(input);
  };

  return (
    <Form layout="vertical" form={form} initialValues={values} onFinish={onFinish}>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form.Item name="code" label="Code" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="sizeSizeGroups" label="Sizes">
            <Select
              mode="multiple"
              showSearch
              allowClear
              optionLabelProp="label"
              filterOption={(input, option) => {
                let label = "";
                if (option?.label && isString(option.label)) label = option.label;
                let value = option?.value;
                return (
                  label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
              }}
            >
              {measureSizes.map((size: any) => (
                <Select.Option key={size.id} value={size.id} label={size.code}>
                  {size.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
